/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateZoneRequestDto,
  GetZoneAssetsMapResponseDto,
  UpdateZoneRequestDto,
  ZoneResponseDto,
} from '../models/index';
import {
    CreateZoneRequestDtoFromJSON,
    CreateZoneRequestDtoToJSON,
    GetZoneAssetsMapResponseDtoFromJSON,
    GetZoneAssetsMapResponseDtoToJSON,
    UpdateZoneRequestDtoFromJSON,
    UpdateZoneRequestDtoToJSON,
    ZoneResponseDtoFromJSON,
    ZoneResponseDtoToJSON,
} from '../models/index';

export interface ZoneControllerCreateZoneRequest {
    siteId: string;
    organizationId: string;
    createZoneRequestDto: CreateZoneRequestDto;
}

export interface ZoneControllerDeleteZoneRequest {
    id: string;
    siteId: string;
    organizationId: string;
}

export interface ZoneControllerFindZoneAssetsMapByIdRequest {
    id: string;
    siteId: string;
    organizationId: string;
}

export interface ZoneControllerFindZoneByIdRequest {
    id: string;
    siteId: string;
    organizationId: string;
}

export interface ZoneControllerFindZonesBySiteIdRequest {
    siteId: string;
    organizationId: string;
}

export interface ZoneControllerUpdateZoneRequest {
    id: string;
    siteId: string;
    organizationId: string;
    updateZoneRequestDto: UpdateZoneRequestDto;
}

/**
 * 
 */
export class ZonesApi extends runtime.BaseAPI {

    /**
     */
    async zoneControllerCreateZoneRaw(requestParameters: ZoneControllerCreateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ZoneResponseDto>> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling zoneControllerCreateZone().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling zoneControllerCreateZone().'
            );
        }

        if (requestParameters['createZoneRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createZoneRequestDto',
                'Required parameter "createZoneRequestDto" was null or undefined when calling zoneControllerCreateZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/zones`;
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateZoneRequestDtoToJSON(requestParameters['createZoneRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ZoneResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async zoneControllerCreateZone(requestParameters: ZoneControllerCreateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ZoneResponseDto> {
        const response = await this.zoneControllerCreateZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async zoneControllerDeleteZoneRaw(requestParameters: ZoneControllerDeleteZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling zoneControllerDeleteZone().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling zoneControllerDeleteZone().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling zoneControllerDeleteZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/zones/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async zoneControllerDeleteZone(requestParameters: ZoneControllerDeleteZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.zoneControllerDeleteZoneRaw(requestParameters, initOverrides);
    }

    /**
     */
    async zoneControllerFindZoneAssetsMapByIdRaw(requestParameters: ZoneControllerFindZoneAssetsMapByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetZoneAssetsMapResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling zoneControllerFindZoneAssetsMapById().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling zoneControllerFindZoneAssetsMapById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling zoneControllerFindZoneAssetsMapById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/zones/{id}/assets-map`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetZoneAssetsMapResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async zoneControllerFindZoneAssetsMapById(requestParameters: ZoneControllerFindZoneAssetsMapByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetZoneAssetsMapResponseDto> {
        const response = await this.zoneControllerFindZoneAssetsMapByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async zoneControllerFindZoneByIdRaw(requestParameters: ZoneControllerFindZoneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ZoneResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling zoneControllerFindZoneById().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling zoneControllerFindZoneById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling zoneControllerFindZoneById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/zones/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ZoneResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async zoneControllerFindZoneById(requestParameters: ZoneControllerFindZoneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ZoneResponseDto> {
        const response = await this.zoneControllerFindZoneByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async zoneControllerFindZonesBySiteIdRaw(requestParameters: ZoneControllerFindZonesBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ZoneResponseDto>>> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling zoneControllerFindZonesBySiteId().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling zoneControllerFindZonesBySiteId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/zones`;
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ZoneResponseDtoFromJSON));
    }

    /**
     */
    async zoneControllerFindZonesBySiteId(requestParameters: ZoneControllerFindZonesBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ZoneResponseDto>> {
        const response = await this.zoneControllerFindZonesBySiteIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async zoneControllerUpdateZoneRaw(requestParameters: ZoneControllerUpdateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ZoneResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling zoneControllerUpdateZone().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling zoneControllerUpdateZone().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling zoneControllerUpdateZone().'
            );
        }

        if (requestParameters['updateZoneRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateZoneRequestDto',
                'Required parameter "updateZoneRequestDto" was null or undefined when calling zoneControllerUpdateZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/zones/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateZoneRequestDtoToJSON(requestParameters['updateZoneRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ZoneResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async zoneControllerUpdateZone(requestParameters: ZoneControllerUpdateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ZoneResponseDto> {
        const response = await this.zoneControllerUpdateZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
